import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config, LoggingService, PaymentService } from '@fgb/core';

@Component({
  selector: 'fgb-unified-checkout-results-page',
  templateUrl: './unified-checkout-results-page.component.html',
  styleUrl: './unified-checkout-results-page.component.scss',
})
export class UnifiedCheckoutResultsPageComponent {
  private paymentService = inject(PaymentService);
  private successUrl = '/payment/checkout/success';
  private failureUrl = '/payment/checkout/failure';

  constructor(
    private route: ActivatedRoute,
    private logService: LoggingService,
    public router: Router
  ) {}

  ngOnInit() {
    const orderId = this.readOrderId();

    if (!orderId) {
      this.logService.error('No order ID could be found in the query string');
      return;
    }

    const callbackUrl = config.baseApiUrl + this.router.url;

    const params = {
      orderId,
    };

    this.paymentService.completePayment(params, callbackUrl, this.successUrl, this.failureUrl);
  }

  /**
   * The order id from the url, whatever case it arrives in.
   *
   * queryParamMap.get() is an exact match, and the provider decides the casing
   * on the way back - FreedomPay returns `?OrderId=`. Reading only the
   * lower-cased spelling loses it and the payment is never verified.
   */
  private readOrderId(): string | undefined {
    const params = this.route.snapshot.queryParamMap;
    const key = params.keys.find((candidate) => candidate.toLowerCase() === 'orderid');

    return (key ? params.get(key) : null) || undefined;
  }
}
